import * as React from "react";
import { AirlineAgeRules } from "./AirlineAgeRules";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { LocalizedText } from "bernie-l10n";
import { UitkRadio, UitkRadioGroup } from "uitk-react-switch";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";

export enum AirlineChildSeatingOptions {
  IN_SEAT = "seat",
  ON_LAP = "lap"
}

const AirlineChildSeatingText = () => {
  return (
    <p className="airlineChildSeatingText uitk-type-300 uitk-type-bold">
      <LocalizedText message={locKeys.airlineChildSeatingMessage} />
    </p>
  );
};

const AirlineChildSeatingRadio = ({
  airlineChildSeating,
  changeAirlineChildSeating,
  isChildUnderTwoPresent
}: {
  airlineChildSeating: AirlineChildSeatingOptions;
  changeAirlineChildSeating: (event: React.ChangeEvent<HTMLFormElement>) => void;
  isChildUnderTwoPresent: boolean;
}) => {
  if (!isChildUnderTwoPresent) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div>
      <UitkRadioGroup group="ChildSeating" onChange={changeAirlineChildSeating} selected={airlineChildSeating}>
        <UitkRadio
          id="ChildOnLap"
          labelClassName="all-r-padding-six"
          label={formatText(locKeys.airlineSeatingOnLap)}
          value={AirlineChildSeatingOptions.ON_LAP}
        />
        <UitkRadio
          id="ChildInSeat"
          labelClassName="all-r-padding-six"
          label={formatText(locKeys.airlineSeatingInSeat)}
          value={AirlineChildSeatingOptions.IN_SEAT}
        />
      </UitkRadioGroup>
    </div>
  );
};

// Parent component of AirlineChildSeatingText, AirlineChildSeatingRadio, and AirlineAgeRules
export const AirlineChildSeating = ({
  isFlightAdded,
  airlineChildSeating,
  changeAirlineChildSeating,
  isChildUnderTwoPresent
}: {
  isFlightAdded?: boolean;
  airlineChildSeating: AirlineChildSeatingOptions;
  changeAirlineChildSeating: (event: React.ChangeEvent<HTMLFormElement>) => void;
  isChildUnderTwoPresent: boolean;
}) => {
  if (!isFlightAdded) {
    return null;
  }
  if (!isChildUnderTwoPresent) {
    // Desktop requires a spacer
    return (
      <Viewport>
        <ViewLarge>
          <div className="uitk-cell l-cell-1-3 xl-cell-1-3" />
        </ViewLarge>
      </Viewport>
    );
  }

  const airlineAgeRules = (
    <AirlineAgeRules isFlightAdded={isFlightAdded} isChildUnderTwoPresent={isChildUnderTwoPresent} />
  );

  const airlineChildSeatingText = (
    <AirlineChildSeatingRadio
      airlineChildSeating={airlineChildSeating}
      changeAirlineChildSeating={changeAirlineChildSeating}
      isChildUnderTwoPresent={isChildUnderTwoPresent}
    />
  );

  return (
    <Viewport>
      <ViewSmall>
        <div className="airlineChildSeating uitk-cell s-cell-1-1">
          {airlineAgeRules}
          <AirlineChildSeatingText />
          {airlineChildSeatingText}
        </div>
      </ViewSmall>

      <ViewMedium>
        <div className="airlineChildSeating uitk-cell m-cell-1-1">
          <AirlineChildSeatingText />
          {airlineAgeRules}
          {airlineChildSeatingText}
        </div>
      </ViewMedium>

      <ViewLarge>
        <div className="airlineChildSeating uitk-cell l-cell-1-3 xl-cell-1-3">
          <AirlineChildSeatingText />
          {airlineAgeRules}
          {airlineChildSeatingText}
        </div>
      </ViewLarge>
    </Viewport>
  );
};
